import { useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance";

const useIndiaLocation = () => {
  const [isIndiaLocation, setIsIndiaLocation] = useState(false);

  useEffect(() => {
    let isMounted = true;

    axiosInstance
      .get("api/user-location/", { skipJwtAuth: true })
      .then((response) => {
        if (!isMounted) return;

        setIsIndiaLocation(response?.data?.is_india === true);
      })
      .catch(() => {
        if (!isMounted) return;

        setIsIndiaLocation(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return isIndiaLocation;
};

export default useIndiaLocation;
